import { GrowthBook } from '@growthbook/growthbook';
import { thirdPartyTrackingPlugin, autoAttributesPlugin } from '@growthbook/growthbook/plugins';
// import { trackGTMEvent } from 'src/helpers/gtm/gtmEvents';

// GrowthBook config is the single source of truth for feature flag fetching, environment, and plugins.
// To keep local dev clean, you can disable streaming and analytics plugins in development.
// See App.tsx for where init() is called.
const growthbook = new GrowthBook({
  apiHost: process.env.REACT_APP_GROWTHBOOK_API_HOST,
  clientKey: process.env.REACT_APP_GROWTHBOOK_CLIENT_KEY,
  decryptionKey: process.env.REACT_APP_GROWTHBOOK_DECRYPTION_KEY!,
  enableDevMode: true,
  plugins: [autoAttributesPlugin(), thirdPartyTrackingPlugin({ trackers: ['gtm'] })],
  disableCache: true,
  trackingCallback: (experiment, result) => {
    console.log(
      '[GrowthBook] Experiment started:',
      experiment.key,
      'Variation:',
      result.variationId,
    );
    // trackGTMEvent('$experiment_started', {
    //   experimentName: experiment.key,
    //   bannerVariant: experiment.variations[result.variationId],
    // });
  },
});

export default growthbook;
